/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import { Formik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import SpinnerButton from "../../Button";
import { useAuth } from "../../../context/AuthContext";
import { handleErrors } from "../../../services/handleErrors";

const ProfileForm = ({ isRemplacing }) => {
  const { currentUser, updateUserData, refreshToken } = useAuth();

  const updateProfile = async (values, actions) => {
    try {
      await updateUserData(values);
    } catch (err) {
      handleErrors(err, toast.error, refreshToken);
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{
        nombre: currentUser.user.nombre,
        apellido: currentUser.user.apellido,
        email: currentUser.user.email,
        telefono: `${parseInt(currentUser.user.telefono, 10)}`.padStart(10, "0"),
      }}
      onSubmit={updateProfile}
      validationSchema={Yup.object().shape({
        telefono: Yup.string()
          .test("len", "Debe ser un numero de 10 digitos", (val) => val.length === 10)
          .required("Este campo es requerido."),
      })}
    >
      {(props) => {
        const { values, touched, errors, isSubmitting, handleChange, handleBlur, handleSubmit } = props;
        return (
          <form className="card dmx-card-mt" onSubmit={handleSubmit}>
            <div className="card-header">
              <h5>Mi Perfil</h5>
              <div className="card-options">
                <a className="card-options-collapse" href="javascript" data-toggle="card-collapse" aria-label="Toggle Card">
                  <i className="fe fe-chevron-up" />
                </a>
                <a className="card-options-remove" href="javascript" data-toggle="card-remove" aria-label="Remove Card">
                  <i className="fe fe-x" />
                </a>
              </div>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-sm-6 col-md-6">
                  <div className="form-group">
                    <p className="form-label mb-1">Nombre</p>
                    <input
                      className={errors.nombre && touched.nombre ? "form-control error-field" : "form-control"}
                      type="string"
                      placeholder="Nombre"
                      name="nombre"
                      disabled
                      value={values.nombre}
                    />
                    {errors.nombre && touched.nombre && <div className="input-feedback">{errors.nombre}</div>}
                  </div>
                </div>
                <div className="col-sm-6 col-md-6">
                  <div className="form-group">
                    <p className="form-label mb-1">Apellido</p>
                    <input
                      className={errors.apellido && touched.apellido ? "form-control error-field" : "form-control"}
                      type="string"
                      placeholder="Nombre"
                      name="apellido"
                      disabled
                      value={values.apellido}
                    />
                    {errors.apellido && touched.apellido && <div className="input-feedback">{errors.apellido}</div>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6 col-md-6">
                  <div className="form-group">
                    <p className="form-label mb-1">Email</p>
                    <input
                      className={errors.email && touched.email ? "form-control error-field" : "form-control"}
                      type="email"
                      placeholder="Email"
                      name="email"
                      disabled
                      value={values.email}
                    />
                    {errors.email && touched.email && <div className="input-feedback">{errors.email}</div>}
                  </div>
                </div>
                <div className="col-sm-6 col-md-6">
                  <div className="form-group">
                    <p className="form-label mb-1">Telefono</p>
                    <input
                      className={errors.telefono && touched.telefono ? "form-control error-field" : "form-control"}
                      type="telefono"
                      placeholder="Telefono"
                      name="telefono"
                      disabled={isSubmitting || isRemplacing}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.telefono}
                    />
                    {errors.telefono && touched.telefono && <div className="input-feedback">{errors.telefono}</div>}
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer text-right">
              <SpinnerButton className="btn btn-primary" isLoading={isSubmitting} type="submit" disabled={isRemplacing}>
                Actualizar Perfil
              </SpinnerButton>
            </div>
          </form>
        );
      }}
    </Formik>
  );
};

export default ProfileForm;
